import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { DeviceID, DeviceIdentityData } from '@playq/octopus2-devices';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

export const updateDevice: MutationKey = ['update', 'device'];

export const useUpdateDevice = (
  options?: UseMutationOptionsExtended<
    CommonSuccess,
    GenericFailure | Error,
    { device: DeviceID; data: DeviceIdentityData }
  >
) =>
  useEitherMutation(({ device, data }) => services2.onlineDeviceService.updateDevice(device, data), {
    mutationKey: updateDevice,
    ...options,
  });
